import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable} from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from '../user/services/auth.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
  })
export class TokenInterceptor implements HttpInterceptor {

    constructor(
        private router:Router,
        private authService:AuthService) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(this.authService.isLoggedIn){
           const authToken = this.authService.getAuthToken(); 
           request = request.clone({
               setHeaders : {
                   'Authorization': `Bearer ${authToken}`
               }
           })
        }
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if(event instanceof HttpResponse){
                    // handle success response
                }
            },(err:any) => {
                if(err instanceof HttpErrorResponse){
                    if(err.status === 401){
                      this.authService.logout();
                      this.router.navigate(['/user/login']);
                    }
                }
            })
        );
        
    }
}
